import moment from 'moment'
import path from 'path'

import { jobStatus } from '../components/utils'

export function extractReceipts(receipts) {
    const newReceipts = {
        rented_gear: [],
        meals: [],
        hard_drive: [],
        shipping: [],
        gas: [],
        parking: [],
        taxi: [],
        additional: [],
    }

    if (receipts) {
        for (const receipt of receipts) {
            if (receipt.receipt_type) {
                newReceipts[receipt.receipt_type.toLowerCase()].push({
                    uuid: receipt.uuid,
                    file: receipt.receipt,
                    name: path.basename(receipt.receipt_name),
                })
            } else {
                newReceipts.additional.push({
                    uuid: receipt.uuid,
                    file: receipt.receipt,
                    name: path.basename(receipt.receipt_name),
                })
            }
        }
    }

    return newReceipts
}

function normaliseInvoice(invoice) {
    invoice.created_date = moment(invoice.created_date)
    invoice.receipts = extractReceipts(invoice.receipts)

    return invoice
}

function normaliseJob(job) {
    job.job_date = moment(job.job_date)

    if (job.pay_date) {
        job.pay_date = moment(job.pay_date)
    } else {
        job.pay_date = { format: () => 'No pay date set' }
    }

    if (job.invoice_obj) {
        job.invoice_obj = normaliseInvoice(job.invoice_obj)
    }

    return job
}

const initialState = {
    history: null,
    job: null,
    upload: {
        files: [],
        errros: null,
    },
    errorModal: false,
    errors: {},
}

export default function jobs(state = initialState, action) {
    switch (action.type) {
        case 'SIGN_OUT':
            return initialState

        case 'LOAD_JOBS_SUCCESS':
            // patch state with the job history
            return {
                ...state,
                history: action.data.map(normaliseJob),
            }
        case 'LOAD_JOBS_ERROR':
            // clear history on error
            return {
                ...state,
                history: null,
            }

        case 'LOAD_JOB_SUCCESS':
            // patch state with the job
            return {
                ...state,
                job: normaliseJob(action.data),
            }
        case 'LOAD_JOB_ERROR':
            // clear job on error
            return {
                ...state,
                job: null,
            }

        case 'CLEAR_JOB':
            return {
                ...state,
                job: null,
            }

        case 'RECEIPT_UPLOAD_SUCCESS':
            return state

        case 'RECEIPT_UPLOAD_ERROR':
            return {
                ...state,
                errors: action.errors || {},
            }

        case 'SUBMIT_INVOICE_SUCCESS':
            return {
                ...state,
                history: null,
                errors: {},
                job: (state.job && (state.job.uuid === action.data.production_crew)) ? {
                    ...state.job,
                    invoice_obj: normaliseInvoice(action.data),
                } : state.job,
            }

        case 'SUBMIT_INVOICE_ERROR':
            return {
                ...state,
                errors: action.errors || {},
                errorModal: Date.now(),
            }

        case 'REQUEST_OVERTIME_SUCCESS':
            return {
                ...state,
                errors: {},
                history: state.history ? state.history.map((job) => {
                    if (job.uuid === action.data.production_crew) {
                        return {
                            ...job,
                            job_status: jobStatus.OVERTIME_REQUESTED,
                        }
                    }

                    return job
                }) : null,
                job: (state.job && (state.job.uuid === action.data.production_crew)) ? {
                    ...state.job,
                    job_status: jobStatus.OVERTIME_REQUESTED,
                } : state.job,
            }

        case 'REQUEST_OVERTIME_ERROR':
            return {
                ...state,
                errors: action.errors || {},
            }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./app/reducers/jobs.js